export const css = {
	root: 'Vs0yehcX',
	pressed: '_1wlY-2zi',
	disabled: '_3droe7vq',
	label: '_12hbQ1Fx',
	' _key': 'afcpe-theme/afcpe/dojo/button'
};

export default css;
